const shadows = {
  notice: {
    shadowColor: '#000',
    shadowOffset: { width: 2, height: 4 },
    shadowOpacity: 0.07,
    shadowRadius: 8,
    elevation: 8,
  },
};

export default shadows;
